window.upsellProducts = {
    100516: "100516-adhesive-cable-management-clip-organizers-4-pack",
    100517: "100517-adhesive-cable-management-clip-organizers-8-pack",
    945014: "945014-cig-plug-adapter-with-dual-ports-one-usb-c-and-one-usb-a-port",
    100297: "sunglasses-clip-for-car-visor",
    102805: "102805-golf-cart-phone-caddy",
    100298: "100298-foldable-desk-phone-stand",
    100649: "100649-collapsible-car-trash-can",
    100493: 'car-headrest-hook-with-built-in-phone-holder',
}

window.upsellConditions = {
    100516: { min: 0, max: 2, tag: '', notag: ''},
    100517: { min: 3, max: 10000, tag: '', notag: ''},
    945014: { min: 0, max: 10000, tag: '', notag: 'Power:Charging'},
}